import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import RemindPasswordMutation from './AuthRemindPasswordMutation';

const RemindPasswordConnectorApollo = ({ children }) => {
  const [mutate, { loading }] = useMutation(RemindPasswordMutation);

  const createRemindPassword = async (request) => {
    const variables = request;

    const response = await mutate({
      variables,
    });

    return response;
  };

  return children({
    remindPassword: createRemindPassword,
    loading,
  });
};

RemindPasswordConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default RemindPasswordConnectorApollo;
